import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/i18n";
import { Logo } from "@/components/Logo";
import { LangToggle } from "@/components/Navbar";

const NEEDS = {
  es: [
    { label: "Quiero ahorrar en AWS", to: "/aws/services/aws-reselling", accent: "#f59c1a" },
    { label: "Optimizar mis costes cloud", to: "/aws/services/aws-cost-optimization", accent: "#f59c1a" },
    { label: "Migrar a la nube", to: "/aws/services/aws-migration", accent: "#f59c1a" },
    { label: "Modelos de datos y calidad del dato", to: "/aws/services/databases-data-models", accent: "#f59c1a" },
    { label: "Entender cómo trabajan mis equipos", to: "/people-hr", accent: "#0d9488" },
    { label: "Bienestar y desconexión digital", to: "/people-hr", accent: "#0d9488" },
    { label: "Medir mi marketing (GA4, GTM)", to: "/martech", accent: "#ca3b42" },
    { label: "Dashboards en Power BI o Looker", to: "/martech", accent: "#ca3b42" },
    { label: "Segmentación, scoring y propensión", to: "/martech", accent: "#ca3b42" },
    { label: "No lo tengo claro, quiero hablar", to: "/contact", accent: "#4361ee" },
  ],
  en: [
    { label: "I want to save on AWS", to: "/aws/services/aws-reselling", accent: "#f59c1a" },
    { label: "Optimize my cloud costs", to: "/aws/services/aws-cost-optimization", accent: "#f59c1a" },
    { label: "Migrate to the cloud", to: "/aws/services/aws-migration", accent: "#f59c1a" },
    { label: "Data models & data quality", to: "/aws/services/databases-data-models", accent: "#f59c1a" },
    { label: "Understand how my teams work", to: "/people-hr", accent: "#0d9488" },
    { label: "Wellbeing & digital disconnection", to: "/people-hr", accent: "#0d9488" },
    { label: "Measure my marketing (GA4, GTM)", to: "/martech", accent: "#ca3b42" },
    { label: "Dashboards in Power BI or Looker", to: "/martech", accent: "#ca3b42" },
    { label: "Segmentation, scoring & propensity", to: "/martech", accent: "#ca3b42" },
    { label: "Not sure yet, let's talk", to: "/contact", accent: "#4361ee" },
  ],
};

const HomeE = () => {
  const { t, lang } = useLang();
  const needs = NEEDS[lang];

  return (
    <div data-testid="home-e" className="min-h-[100svh] bg-[#FAFAFD] text-[#353535] flex flex-col">
      <div className="flex items-center justify-between px-5 sm:px-8 pt-6">
        <Logo />
        <LangToggle />
      </div>
      <div className="flex-1 flex flex-col justify-center px-5 sm:px-8 py-14">
        <div className="mx-auto w-full max-w-[900px] text-center">
          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="font-cabinet font-bold tracking-tight leading-[1.05] text-[9vw] sm:text-6xl"
          >
            {lang === "es" ? (
              <>¿Qué <span className="text-[#4361ee]">necesitas?</span></>
            ) : (
              <>What do you <span className="text-[#4361ee]">need?</span></>
            )}
          </motion.h1>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="mt-5 font-jakarta text-base text-[#999999] max-w-lg mx-auto"
          >
            {t.gateway.sub}
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="mt-12 flex flex-wrap justify-center gap-3"
          >
            {needs.map((n, i) => (
              <Link
                key={i}
                to={n.to}
                data-testid={`homee-need-${i}`}
                className="group inline-flex items-center gap-2.5 rounded-full border border-black/12 bg-white px-6 py-3.5 text-sm font-jakarta font-medium transition-all duration-300 hover:-translate-y-0.5 hover:text-white"
                style={{ borderLeftColor: n.accent, borderLeftWidth: 3 }}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = n.accent; e.currentTarget.style.borderColor = n.accent; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#ffffff"; e.currentTarget.style.borderColor = "rgba(0,0,0,0.12)"; e.currentTarget.style.borderLeftColor = n.accent; }}
              >
                {n.label}
                <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            ))}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default HomeE;
